<template>
    <div>
        <h3>評価者平均と本人採点</h3>
        <div class="all-chart" ref="wrapper">
        </div>
    </div>
</template>


<script>
// グラフを重ねて描きたい場合はここらへん
// https://plot.ly/python/radar-chart/
import Plotly from 'plotly.js-dist';


export default {
    props: {
        items: {
            required: true
        },
        forPrint: {
            default: false,
        }
    },
    mounted() {
        const x = []
        const y1 = []
        const y2 = []
        const y3 = []
        const text = []
        const color = []
        this.items.forEach(i => {
            x.push(i.id)
            y1.push(i.meanScore)
            y2.push(i.self)
            text.push(i.id.toString() + " : " + i.question)
            color.push(i.color)
        });

        const data = [
            {
                name: "評価者平均",
                type: 'bar',
                x: x,
                y: y1,
                text: text,
                marker: {
                    color: color
                },
            },
            {
                name: "本人",
                type: 'scatter',
                mode: 'lines+markers',
                x: x,
                y: y2,
                marker: {
                    color: "#000000"
                }
            },
            {
                name: "上司",
                type: 'scatter',
                mode: 'lines+markers',
                x: x,
                y: y3,
                marker: {
                    color: "#673AB7"
                }
            }
        ]
        var layout = {
            // title: '評価者平均と本人採点',
            showlegend: false,
            font: {
                family: 'Raleway, sans-serif'
            },
            yaxis: {
                fixedrange: true
            },
            xaxis: {
                fixedrange: true,
                ...(
                    this.forPrint ? {
                        tickangle: 30,
                        tickvals: this.items.map(item => item.id),
                        ticktext: this.items.map(item => item.question),
                        tickfont: { size: 9 },
                    } : {}
                )
            },
            autosize: false,
            ...(
                this.forPrint ? {
                    width: 1500,
                    height: 600,
                    margin: {
                        b: 250,
                        r: 270,
                    }
                } : {
                        width: 1000,
                        height: 500,
                    }
            )
        };
        console.log(data)
        Plotly.plot(this.$refs.wrapper, data, layout, {
            displayModeBar: false, // 右上のツールバーを非表示
            staticPlot: false, // マウスで拡大できないように
        }).then(el => {
            this.$emit('plot-done', el)
        })
    },
    beforeDestroy() {
        Plotly.purge(this.$refs.wrapper)
    }
}


function range(n) {
    const a = []
    for (let i = 0; i < n; ++i) {
        a[i] = i
    }
    return a
}
</script>

